@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/graphics-panel/emoji-editor/clipping-studio-emoji-editor.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.emoji-editor__scroll-wrap::-webkit-scrollbar,
.emoji-editor__body::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.emoji-editor__scroll-wrap::-webkit-scrollbar-button,
.emoji-editor__body::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.emoji-editor__scroll-wrap::-webkit-scrollbar-corner,
.emoji-editor__body::-webkit-scrollbar-corner {
  background: transparent;
}
.emoji-editor__scroll-wrap::-webkit-scrollbar-thumb:hover,
.emoji-editor__body::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.emoji-editor__scroll-wrap::-webkit-scrollbar-thumb,
.emoji-editor__body::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.emoji-editor__scroll-wrap::-webkit-scrollbar-thumb:hover,
.emoji-editor__body::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.emoji-editor__scroll-wrap::-webkit-scrollbar-track:hover,
.emoji-editor__body::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.emoji-editor__scroll-wrap::-webkit-scrollbar-track,
.emoji-editor__body::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.emoji-editor {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  border: none;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  z-index: 20;
  font-family: "Open Sans", sans-serif;
}
.emoji-editor__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
}
.emoji-editor__header-title {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  font-family: "Open Sans", sans-serif;
}
.emoji-editor__close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.emoji-editor__close-btn:hover {
  color: rgba(0, 0, 0, 0.85);
}
.emoji-editor__body {
  flex: 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.emoji-editor__section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.emoji-editor__error-text {
  font-size: 12px;
  margin: 0;
  color: #ef5350;
}
.emoji-editor__loading {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.35);
  margin: 0;
  padding: 8px 0;
}
.emoji-editor__label {
  font-family: "Open Sans", sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.35);
  text-transform: uppercase;
}
.emoji-editor__search {
  width: 100%;
  padding: 8px 10px;
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  box-sizing: border-box;
}
.emoji-editor__search::placeholder {
  color: rgba(0, 0, 0, 0.35);
}
.emoji-editor__search:focus {
  outline: none;
  border-color: rgb(45, 187, 252);
}
.emoji-editor__scroll-wrap {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  padding: 8px;
  background: rgb(255, 255, 255);
}
.emoji-editor__grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 6px;
}
.emoji-editor__emoji-btn {
  aspect-ratio: 1;
  padding: 4px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  background: rgb(255, 255, 255);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  font-size: 1.25rem;
}
.emoji-editor__emoji-btn:hover {
  border-color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.06);
}
.emoji-editor__emoji-btn--selected {
  border-color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.12);
}
.emoji-editor__emoji-char {
  line-height: 1;
  -webkit-user-select: none;
  user-select: none;
}
.emoji-editor__time-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: column;
}
.emoji-editor__time-input-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-width: 0;
}
.emoji-editor__time-input {
  flex: 1;
  min-width: 0;
  padding: 6px 8px;
  font-size: 12px;
  font-family: monospace;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
}
.emoji-editor__time-now-btn {
  flex-shrink: 0;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  color: rgb(45, 187, 252);
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
}
.emoji-editor__time-now-btn:hover {
  background: rgba(45, 187, 252, 0.08);
}
.emoji-editor .emoji-editor__scale-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
}
.emoji-editor .emoji-editor__slider {
  flex: 1;
  min-width: 0;
  height: 8px;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  border: none;
  outline: none;
}
.emoji-editor .emoji-editor__slider::-webkit-slider-runnable-track {
  height: 4px;
  background: #e1e6eb;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 2px;
}
.emoji-editor .emoji-editor__slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgb(45, 187, 252);
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.14);
  cursor: pointer;
  margin-top: -6px;
}
.emoji-editor .emoji-editor__slider::-moz-range-track {
  height: 4px;
  background: #e1e6eb;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 2px;
}
.emoji-editor .emoji-editor__slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgb(45, 187, 252);
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.14);
  cursor: pointer;
}
.emoji-editor .emoji-editor__number {
  width: 70px;
  padding: 6px 6px;
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  box-sizing: border-box;
}
.emoji-editor__footer {
  padding: 12px 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.14);
}
.emoji-editor__save-btn {
  width: 100%;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 700;
  border: none;
  border-radius: 6px;
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
}
.emoji-editor__save-btn:hover {
  opacity: 0.9;
}
/*# sourceMappingURL=clipping-studio-emoji-editor.component.css.map */
